import React, { memo } from 'react';
import ComponentErrorBoundary from '../../layout/ComponentErrorBoundary/ComponentErrorBoundary';

const fallback = (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      gap: '16px',
      padding: '24px',
      textAlign: 'center',
    }}
  >
    <p style={{ margin: 0, fontSize: '1.1rem' }}>
      Something went wrong loading this page.
    </p>
    <button
      data-test-id="restaurant-error-reload"
      type="button"
      onClick={() => window.location.reload()}
      style={{
        padding: '10px 24px',
        cursor: 'pointer',
        borderRadius: '4px',
        border: '1px solid currentColor',
        background: 'transparent',
        fontSize: '1rem',
      }}
    >
      Reload
    </button>
  </div>
);

function withRestaurantErrorBoundary(Component) {
  function RestaurantPage() {
    return (
      <ComponentErrorBoundary name="RestaurantPage" fallback={fallback}>
        <Component />
      </ComponentErrorBoundary>
    );
  }
  return memo(RestaurantPage);
}

export default withRestaurantErrorBoundary;
